export const fullName = (user) => {
  return (user?.first_name ?? "") + " " + (user?.last_name ?? "");
};

export const initials = (user) => {
  return (user?.first_name?.[0] ?? "") + (user?.last_name?.[0] ?? "");
};

export function assetUrl(id) {
  if (!id) {
    return null;
  }
  const baseUrl =
    (typeof import.meta !== "undefined" && import.meta.env?.VITE_BASE_URL) ||
    process.env.NEXT_PUBLIC_BASE_URL ||
    "";
  return `${baseUrl}/assets/${id}`;
}